import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    console.log('Find me in app/javascript/controllers/application/home_controller.js');
  }
}
